enum ConstituentField {
  // Common fields
  ATTACHMENTS = 'attachments',
  AVATAR = 'avatar',
  DISPLAY_NAME = 'displayName',
  EMAILS = 'emails',
  PHONES = 'phones',
  ADDRESSES = 'addresses',
  BIOGRAPHY = 'biography',
  CATEGORY_BOARD_MEMBER = 'categoryBoardMember',
  CATEGORY_MEMBER = 'categoryMember',
  CATEGORY_PARTNER = 'categoryPartner',
  CATEGORY_RECIPIENT = 'categoryRecipient',
  CATEGORY_VOLUNTEER = 'categoryVolunteer',
  CONSTITUENT_TYPE = 'constituentType',
  CUSTOM_FIELDS = 'customFields',
  LABEL_IDS = 'labelIds',
  WEBSITE = 'website',
  INSTAGRAM = 'instagram',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  FACEBOOK = 'facebook',
  YOUTUBE = 'youtube',
  TIKTOK = 'tiktok',
  NOTE_1 = 'note_1',
  NOTE_2 = 'note_2',
  NOTE_3 = 'note_3',

  // Person-specific fields
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PREFERRED_FIRST_NAME = 'preferredFirstName',
  PREFIX = 'prefix',
  PRONOUNS = 'pronouns',
  DOB = 'dob',
  IS_DECEASED = 'is_deceased',

  // Org-specific fields
  ORG_NAME = 'orgName',
  INDUSTRY = 'industry',
  CATEGORY_CORPORATION = 'categoryCorporation',
  CATEGORY_FOUNDATION = 'categoryFoundation',
  CATEGORY_GOVERNMENT = 'categoryGovernment',

  // Rulesets
  IS_DONOR_RULESET = 'isDonorRuleset',
  IS_MAJOR_DONOR_RULESET = 'isMajorDonorRuleset',
  IS_RECURRING_DONOR_RULESET = 'isRecurringDonorRuleset',
}

export default ConstituentField;
